import React, { useCallback, useEffect, useState } from 'react';
import './Admin.css';
import { useNavigate } from 'react-router-dom';

const API_ROOT = process.env.REACT_APP_API_URL || (window.location.port === '3000'
  ? '/api'
  : `${process.env.PUBLIC_URL || ''}/api`);

// ─── Icons (inline SVG) ──────────────────────────────────────────────────────
const IC = {
  Logo: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  ),
  Products: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    </svg>
  ),
  Solutions: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  Articles: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
    </svg>
  ),
  Contact: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.63 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.96a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z"/>
    </svg>
  ),
  Compliance: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  Search: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  ),
  Edit: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
  Trash: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
    </svg>
  ),
  Plus: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  Save: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
    </svg>
  ),
  X: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  LogOut: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
  AlertTriangle: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  CheckCircle: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
  ),
  Info: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),
  Menu: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  ),
  Close: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  InboxEmpty: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
    </svg>
  ),
};

// ─── Collections config ──────────────────────────────────────────────────────
const ORDERS_ICON = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>
  </svg>
);

const COLLECTIONS = [
  { id: 'products',        label: 'Products',         Icon: IC.Products    },
  { id: 'solutions',       label: 'Solutions',        Icon: IC.Solutions   },
  { id: 'articles',        label: 'Articles',         Icon: IC.Articles    },
  { id: 'contactDetails',  label: 'Contact Details',  Icon: IC.Contact     },
  { id: 'complianceDocs',  label: 'Compliance Docs',  Icon: IC.Compliance  },
  { id: 'orders',          label: 'Orders',           Icon: ORDERS_ICON    },
];

// ─── Per-collection form schemas ─────────────────────────────────────────────
const FORM_SCHEMAS = {
  products: [
    { key: 'name',     label: 'Product Name', type: 'text',   required: true,  fullWidth: true },
    { key: 'cat',      label: 'Category',     type: 'select', required: true,
      options: ['Bedding', 'Towels', 'Patient Wear', 'Specialty'] },
    { key: 'material', label: 'Material',     type: 'text' },
    { key: 'spec',     label: 'Specification',type: 'text' },
    { key: 'sizes',    label: 'Sizes',        type: 'text' },
    { key: 'feature',  label: 'Key Feature',  type: 'text' },
    { key: 'badge',    label: 'Badge',        type: 'text',  placeholder: 'e.g. Best seller' },
    { key: 'tone',     label: 'Color Tone',   type: 'select',
      options: ['blue', 'teal', 'emerald', 'amber'] },
    { key: 'price',    label: 'Price',        type: 'text',  placeholder: 'e.g. $8.99' },
    { key: 'image',    label: 'Product Image', type: 'image' },
  ],
  solutions: [
    { key: 'title',       label: 'Title',       type: 'text',     required: true, fullWidth: true },
    { key: 'description', label: 'Description', type: 'textarea', required: true, fullWidth: true },
    { key: 'tag',         label: 'Tag / Badge', type: 'text' },
    { key: 'icon',        label: 'Icon Name',   type: 'text', placeholder: 'e.g. Hospital' },
  ],
  articles: [
    { key: 'title',   label: 'Title',    type: 'text',     required: true, fullWidth: true },
    { key: 'excerpt', label: 'Excerpt',  type: 'textarea', fullWidth: true },
    { key: 'date',    label: 'Date',     type: 'text',  placeholder: 'e.g. Jan 2025' },
    { key: 'url',     label: 'URL / Link', type: 'text', placeholder: 'https://...' },
  ],
  contactDetails: [
    { key: 'phone',   label: 'Phone',   type: 'text' },
    { key: 'email',   label: 'Email',   type: 'text' },
    { key: 'address', label: 'Address', type: 'textarea', fullWidth: true },
    { key: 'hours',   label: 'Hours',   type: 'text', placeholder: 'e.g. Mon-Fri 9am–5pm' },
  ],
  complianceDocs: [
    { key: 'title',       label: 'Title',       type: 'text',     required: true, fullWidth: true },
    { key: 'description', label: 'Description', type: 'textarea', fullWidth: true },
    { key: 'docType',     label: 'Doc Type',    type: 'text', placeholder: 'e.g. Certificate' },
    { key: 'fileUrl',     label: 'File URL',    type: 'text', placeholder: 'https://...' },
  ],
};

// ─── Initial Mock Data ────────────────────────────────────────────────────────
const INITIAL_DATA = {
  products: [
    { id: '1', name: 'Premium Hospital Bed Sheet', cat: 'Bedding', material: 'Cotton/poly blend', tone: 'blue', feature: 'Fluid resistant', sizes: 'Twin, full' },
    { id: '2', name: 'Standard Fitted Sheet', cat: 'Bedding', material: 'Knitted cotton', tone: 'teal', badge: 'New' },
  ],
  solutions: [
    { id: '1', title: 'Managed Linen Services', description: 'Comprehensive linen management for healthcare facilities.', tag: 'Popular', icon: 'RefreshCcw' }
  ],
  articles: [],
  contactDetails: [
    { id: '1', phone: '1-800-NOVA-CARE', email: 'support@novacarelines.com', hours: 'Mon-Fri 9am-6pm' }
  ],
  complianceDocs: [
    { id: '1', title: 'ISO 9001 Certificate', description: 'Quality management system certification', docType: 'Certificate' }
  ]
};

// ─── Toast System ─────────────────────────────────────────────────────────────
function ToastContainer({ toasts, removeToast }) {
  const iconMap = {
    success: <IC.CheckCircle />,
    error:   <IC.AlertTriangle />,
    info:    <IC.Info />,
    warning: <IC.AlertTriangle />,
  };
  return (
    <div className="adm-toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`adm-toast ${t.type} ${t.removing ? 'removing' : ''}`}>
          <span className="adm-toast-icon">{iconMap[t.type]}</span>
          <div className="adm-toast-content">
            <p className="adm-toast-title">{t.title}</p>
            {t.msg && <p className="adm-toast-msg">{t.msg}</p>}
          </div>
          <button className="adm-toast-close" onClick={() => removeToast(t.id)}>
            <IC.X />
          </button>
        </div>
      ))}
    </div>
  );
}

function useToast() {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((type, title, msg = '') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, type, title, msg, removing: false }]);
    setTimeout(() => {
      setToasts(prev => prev.map(t => t.id === id ? { ...t, removing: true } : t));
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 300);
    }, 3500);
  }, []);

  const removeToast = useCallback(id => {
    setToasts(prev => prev.map(t => t.id === id ? { ...t, removing: true } : t));
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 300);
  }, []);

  return { toasts, addToast, removeToast };
}

const ADMIN_CREDENTIALS = { username: 'novacarelinens', password: 'Bloodyvenom5$!' };
const AUTH_STORAGE_KEY = 'ncl_admin_authenticated';

function AdminLogin({ onLogin, errorMessage }) {
  const [form, setForm] = useState({ username: '', password: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(form.username, form.password);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #07231f 0%, #0e4b43 45%, #1f6f57 100%)', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: '420px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.16)', borderRadius: '16px', padding: '28px', boxShadow: '0 24px 60px rgba(0,0,0,0.28)', backdropFilter: 'blur(18px)' }}>
        <div style={{ marginBottom: '20px' }}>
          <p style={{ margin: 0, color: '#b6f4dd', fontSize: '12px', letterSpacing: '0.28em', textTransform: 'uppercase', fontWeight: 700 }}>Protected Admin</p>
          <h2 style={{ margin: '8px 0 8px', color: '#fff', fontSize: '24px' }}>Sign in to manage content</h2>
          <p style={{ margin: 0, color: '#d6eee4', fontSize: '14px' }}>Use the hardcoded admin credentials to continue.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '14px' }}>
            <label style={{ display: 'block', color: '#dce7f5', marginBottom: '6px', fontSize: '13px' }}>Username</label>
            <input
              type="text"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              style={{ width: '100%', padding: '11px 12px', borderRadius: '10px', border: '1px solid #22324a', background: '#0c1624', color: '#fff' }}
              placeholder="admin"
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#dce7f5', marginBottom: '6px', fontSize: '13px' }}>Password</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              style={{ width: '100%', padding: '11px 12px', borderRadius: '10px', border: '1px solid #22324a', background: '#0c1624', color: '#fff' }}
              placeholder="••••••"
            />
          </div>

          {errorMessage && <p style={{ marginBottom: '12px', color: '#ff8f8f', fontSize: '13px' }}>{errorMessage}</p>}

          <button type="submit" style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', border: 'none', background: 'linear-gradient(90deg, #22c55e, #0ea5e9)', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}

// ─── Confirm Modal ────────────────────────────────────────────────────────────
function ConfirmModal({ item, onConfirm, onCancel }) {
  return (
    <div className="adm-modal-overlay" onClick={onCancel}>
      <div className="adm-modal" onClick={e => e.stopPropagation()}>
        <div className="adm-modal-icon"><IC.Trash /></div>
        <h3>Delete this item?</h3>
        <p>
          "<strong>{item?.name || item?.title || item?.id}</strong>" will be removed.
        </p>
        <div className="adm-modal-actions">
          <button className="adm-btn adm-btn-ghost" onClick={onCancel}>Cancel</button>
          <button className="adm-btn adm-btn-danger" onClick={onConfirm}>
            <IC.Trash /> Delete
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Image Upload Field ────────────────────────────────────────────────────────
function ImageUploadField({ fieldKey, label, currentUrl, onChange, addToast }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = React.useRef();

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Client-side guard: max 5 MB
    if (file.size > 5 * 1024 * 1024) {
      if (addToast) addToast('error', 'File too large', 'Please upload an image under 5 MB.');
      return;
    }

    const formData = new FormData();
    formData.append('image', file);

    setUploading(true);
    try {
      const res  = await fetch(`${API_ROOT}/upload`, { method: 'POST', body: formData });
      const data = await res.json();
      if (!data.success) throw new Error(data.message || 'Upload failed.');
      onChange(fieldKey, data.url);
      if (addToast) addToast('success', 'Image uploaded', data.filename);
    } catch (err) {
      if (addToast) addToast('error', 'Upload failed', err.message);
    } finally {
      setUploading(false);
      // Reset input so the same file can be re-selected after removal
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div className="adm-img-upload-field">
      {/* Hidden file input */}
      <input
        ref={inputRef}
        id={`adm-f-${fieldKey}`}
        type="file"
        accept="image/jpeg,image/png,image/gif,image/webp"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      {currentUrl ? (
        /* ── Preview ── */
        <div className="adm-img-preview-wrap">
          <img src={currentUrl} alt="Product" className="adm-img-preview" />
          <div className="adm-img-preview-actions">
            <button
              type="button"
              className="adm-img-change-btn"
              onClick={() => inputRef.current?.click()}
              disabled={uploading}
            >
              {uploading ? 'Uploading…' : '↺ Change image'}
            </button>
            <button
              type="button"
              className="adm-img-remove-btn"
              onClick={() => onChange(fieldKey, '')}
            >
              ✕ Remove
            </button>
          </div>
        </div>
      ) : (
        /* ── Drop zone / pick button ── */
        <button
          type="button"
          className={`adm-img-pick-btn ${uploading ? 'uploading' : ''}`}
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
        >
          {uploading ? (
            <>
              <span className="adm-img-spinner" />
              Uploading…
            </>
          ) : (
            <>
              <span style={{ fontSize: '28px', lineHeight: 1 }}>🖼️</span>
              <span style={{ fontWeight: 600, fontSize: '13.5px' }}>Click to upload image</span>
              <span style={{ fontSize: '12px', color: 'var(--color-text-secondary)' }}>
                JPG, PNG, GIF, WebP — max 5 MB
              </span>
            </>
          )}
        </button>
      )}
    </div>
  );
}

// ─── Structured Form ──────────────────────────────────────────────────────────
function StructuredForm({ collectionId, formData, onChange, addToast }) {
  const schema = FORM_SCHEMAS[collectionId] || [];

  return (
    <div className="adm-form-grid">
      {schema.map(field => (
        <div
          key={field.key}
          className={`adm-form-field${field.fullWidth || field.type === 'image' ? ' full-width' : ''}`}
        >
          <label htmlFor={`adm-f-${field.key}`}>
            {field.label}{field.required ? ' *' : ''}
          </label>

          {field.type === 'image' ? (
            <ImageUploadField
              fieldKey={field.key}
              label={field.label}
              currentUrl={formData[field.key] || ''}
              onChange={onChange}
              addToast={addToast}
            />
          ) : field.type === 'textarea' ? (
            <textarea
              id={`adm-f-${field.key}`}
              value={formData[field.key] || ''}
              onChange={e => onChange(field.key, e.target.value)}
              placeholder={field.placeholder || ''}
              rows={3}
            />
          ) : field.type === 'select' ? (
            <select
              id={`adm-f-${field.key}`}
              value={formData[field.key] || ''}
              onChange={e => onChange(field.key, e.target.value)}
            >
              <option value="">— Select —</option>
              {field.options.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          ) : (
            <input
              id={`adm-f-${field.key}`}
              type={field.type || 'text'}
              value={formData[field.key] || ''}
              onChange={e => onChange(field.key, e.target.value)}
              placeholder={field.placeholder || ''}
            />
          )}
        </div>
      ))}
    </div>
  );
}


// ─── Orders View (read-only) ─────────────────────────────────────────────────
const ORDER_STATUSES = ['pending','processing','shipped','delivered','cancelled'];
const STATUS_COLORS  = { pending:'#b45309', processing:'#1d4ed8', shipped:'#0f766e', delivered:'#15803d', cancelled:'#b91c1c' };
const STATUS_BG      = { pending:'rgba(245,158,11,.12)', processing:'rgba(59,130,246,.12)', shipped:'rgba(20,184,166,.12)', delivered:'rgba(34,197,94,.12)', cancelled:'rgba(220,38,38,.12)' };

function OrdersView({ addToast }) {
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  const fetchOrders = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API_ROOT}/orders/all`, {
        headers: { 'X-Admin-Key': 'ncl_admin_2025' },
      });
      const data = await res.json();
      if (data.success) setOrders(data.data || []);
    } catch (e) {
      addToast('error', 'Failed to load orders', e.message);
    } finally {
      setLoading(false);
    }
  }, [addToast]);

  useEffect(() => { fetchOrders(); }, [fetchOrders]);

  const handleStatus = async (orderId, status) => {
    try {
      const res = await fetch(`${API_ROOT}/orders/${orderId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'X-Admin-Key': 'ncl_admin_2025' },
        body: JSON.stringify({ status }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.message);
      setOrders(prev => prev.map(o => o.id === orderId ? { ...o, status } : o));
      addToast('success', 'Status updated', `Order #${orderId} → ${status}`);
    } catch (e) {
      addToast('error', 'Update failed', e.message);
    }
  };

  const handleDeleteOrder = async (orderId) => {
    if (!window.confirm('Are you sure you want to delete this order?')) return;
    try {
      const res = await fetch(`${API_ROOT}/orders/${orderId}`, {
        method: 'DELETE',
        headers: { 'X-Admin-Key': 'ncl_admin_2025' },
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.message);
      setOrders(prev => prev.filter(o => o.id !== orderId));
      addToast('success', 'Order Deleted', `Order #${orderId} has been removed.`);
    } catch (e) {
      addToast('error', 'Delete failed', e.message);
    }
  };

  if (loading) return <div style={{padding:'60px',textAlign:'center',color:'var(--muted)'}}>Loading orders…</div>;
  if (!orders.length) return <div style={{padding:'60px',textAlign:'center',color:'var(--muted)'}}>No orders placed yet.</div>;

  return (
    <div style={{overflowX:'auto'}}>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13.5px'}}>
        <thead>
          <tr style={{background:'rgba(15,91,69,0.06)',textAlign:'left'}}>
            {['ID','Customer','Email','Phone','Address','Items','Total','Status',''].map(h => (
              <th key={h} style={{padding:'12px 14px',fontWeight:700,color:'var(--color-text-secondary)',fontSize:'11.5px',textTransform:'uppercase',letterSpacing:'0.06em',whiteSpace:'nowrap'}}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {orders.map(order => (
            <React.Fragment key={order.id}>
              <tr style={{borderBottom:'1px solid var(--color-border)',cursor:'pointer'}} onClick={() => setExpanded(expanded === order.id ? null : order.id)}>
                <td style={{padding:'13px 14px',fontWeight:700,color:'var(--color-primary)'}}># {order.id}</td>
                <td style={{padding:'13px 14px',fontWeight:600}}>{order.customer_name || '—'}</td>
                <td style={{padding:'13px 14px',color:'var(--color-text-secondary)'}}>{order.customer_email}</td>
                <td style={{padding:'13px 14px',color:'var(--color-text-secondary)'}}>{order.customer_phone || '—'}</td>
                <td style={{padding:'13px 14px',color:'var(--color-text-secondary)',maxWidth:'180px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{order.customer_address || '—'}</td>
                <td style={{padding:'13px 14px'}}>{order.items?.length || 0} item{order.items?.length !== 1 ? 's' : ''}</td>
                <td style={{padding:'13px 14px',fontWeight:800,color:'var(--color-primary)'}}>${parseFloat(order.total).toFixed(2)}</td>
                <td style={{padding:'13px 14px'}}>
                  <select
                    value={order.status}
                    onClick={e => e.stopPropagation()}
                    onChange={e => handleStatus(order.id, e.target.value)}
                    style={{padding:'5px 10px',borderRadius:'8px',border:'1.5px solid var(--color-border)',background:STATUS_BG[order.status],color:STATUS_COLORS[order.status],fontWeight:700,fontSize:'12px',cursor:'pointer'}}
                  >
                    {ORDER_STATUSES.map(s => <option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
                  </select>
                </td>
                <td style={{padding:'13px 14px',color:'var(--color-text-secondary)'}}>{expanded===order.id?'▲':'▼'}</td>
              </tr>
              {expanded === order.id && (
                <tr>
                  <td colSpan={9} style={{padding:'0 14px 16px 14px',background:'rgba(15,91,69,0.03)'}}>
                    <div style={{fontSize:'12.5px',color:'var(--color-text-secondary)',marginTop:'12px'}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                        <strong style={{color:'var(--color-text-primary)'}}>Order items:</strong>
                        <button
                          onClick={() => handleDeleteOrder(order.id)}
                          style={{padding:'4px 12px',background:'#dc2626',color:'white',border:'none',borderRadius:'6px',fontSize:'11.5px',fontWeight:600,cursor:'pointer'}}
                        >
                          Delete Order
                        </button>
                      </div>
                      <div style={{marginTop:'8px',display:'grid',gap:'6px'}}>
                        {(order.items||[]).map((item,i) => (
                          <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'6px 12px',background:'#fff',border:'1px solid var(--color-border)',borderRadius:'8px'}}>
                            <span>{item.product_name}</span>
                            <span style={{color:'var(--color-primary)',fontWeight:700}}>${parseFloat(item.price).toFixed(2)} × {item.qty}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{marginTop:'8px',textAlign:'right',fontWeight:700,color:'var(--color-primary)',fontSize:'14px'}}>
                        Total: ${parseFloat(order.total).toFixed(2)}
                      </div>
                      <p style={{marginTop:'8px',fontSize:'12px'}}><strong>Placed:</strong> {new Date(order.created_at).toLocaleString()}</p>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ─── Main Admin Shell ─────────────────────────────────────────────────────────
function AdminShell({ addToast, onLogout }) {
  const [activeCol, setActiveCol]     = useState(COLLECTIONS[0].id);
  const [dataStore, setDataStore]     = useState(INITIAL_DATA);
  const [selected, setSelected]       = useState(null);
  const [formData, setFormData]       = useState({});
  const [search, setSearch]           = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading]         = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [apiError, setApiError]       = useState('');
  const navigate                      = useNavigate();

  const parseResponse = async (response) => {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      return response.json();
    }
    const text = await response.text();
    throw new Error(text || 'Server returned invalid JSON.');
  };

  const fetchCollection = useCallback(async (collectionId) => {
    setLoading(true);
    setApiError('');

    try {
      const response = await fetch(`${API_ROOT}/admin/${collectionId}`);
      const result = await parseResponse(response);

      if (!response.ok) {
        throw new Error(result.message || 'Unable to load admin data.');
      }

      setDataStore(prev => ({
        ...prev,
        [collectionId]: result.data || []
      }));
    } catch (error) {
      setApiError(error.message);
      addToast('error', 'Load failed', error.message);
    } finally {
      setLoading(false);
    }
  }, [addToast]);

  useEffect(() => {
    if (activeCol !== 'orders') fetchCollection(activeCol);
  }, [activeCol, fetchCollection]);

  // Load items from local store for the active collection
  const items = dataStore[activeCol] || [];

  // Filtered items
  const filtered = items.filter(it => {
    const q = search.toLowerCase();
    return !q ||
      (it.name  || '').toLowerCase().includes(q) ||
      (it.title || '').toLowerCase().includes(q) ||
      (it.tag   || '').toLowerCase().includes(q) ||
      (it.id    || '').toLowerCase().includes(q);
  });

  // Get display name for an item
  function itemLabel(it) {
    return it.name || it.title || it.tag || it.id;
  }

  function itemSub(it) {
    return it.cat || it.docType || it.date || it.phone || it.description?.slice(0,48) || '';
  }

  // Select item → fill form
  function selectItem(it) {
    setSelected(it);
    setFormData({ ...it });
    setSidebarOpen(false);
  }

  // Form field change
  function handleFieldChange(key, value) {
    setFormData(prev => ({ ...prev, [key]: value }));
  }

  // Validate required fields
  function validate() {
    const schema = FORM_SCHEMAS[activeCol] || [];
    const missing = schema.filter(f => f.required && !formData[f.key]?.trim());
    if (missing.length) {
      addToast('warning', 'Required fields missing', missing.map(f => f.label).join(', '));
      return false;
    }
    return true;
  }

  // Add new item to local state
  async function handleAdd() {
    if (!validate()) return;

    try {
      const response = await fetch(`${API_ROOT}/admin/${activeCol}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const result = await parseResponse(response);

      if (!response.ok) {
        throw new Error(result.message || 'Unable to add item.');
      }

      const newItem = {
        ...formData,
        id: result.id?.toString() || Date.now().toString(),
      };

      setDataStore(prev => ({
        ...prev,
        [activeCol]: [...(prev[activeCol] || []), newItem]
      }));

      addToast('success', 'Item added!', `Successfully added to ${activeCol}.`);
      setFormData({});
    } catch (error) {
      addToast('error', 'Add failed', error.message);
    }
  }

  async function handleUpdate() {
    if (!selected) {
      addToast('info', 'No item selected', 'Click an item from the list to edit it.');
      return;
    }
    if (!validate()) return;

    try {
      const response = await fetch(`${API_ROOT}/admin/${activeCol}/${selected.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const result = await parseResponse(response);

      if (!response.ok) {
        throw new Error(result.message || 'Unable to update item.');
      }

      setDataStore(prev => ({
        ...prev,
        [activeCol]: prev[activeCol].map(it => it.id === selected.id ? { ...formData, id: selected.id } : it)
      }));

      addToast('success', 'Updated!', 'Changes saved.');
      setSelected(null);
      setFormData({});
    } catch (error) {
      addToast('error', 'Save failed', error.message);
    }
  }

  function confirmDelete(it) {
    setDeleteTarget(it);
  }

  async function handleDeleteConfirmed() {
    if (!deleteTarget) return;

    try {
      const response = await fetch(`${API_ROOT}/admin/${activeCol}/${deleteTarget.id}`, {
        method: 'DELETE',
      });
      const result = await parseResponse(response);

      if (!response.ok) {
        throw new Error(result.message || 'Unable to delete item.');
      }

      setDataStore(prev => ({
        ...prev,
        [activeCol]: prev[activeCol].filter(it => it.id !== deleteTarget.id)
      }));

      addToast('success', 'Deleted', `"${itemLabel(deleteTarget)}" removed.`);
      if (selected?.id === deleteTarget.id) {
        setSelected(null);
        setFormData({});
      }
      setDeleteTarget(null);
    } catch (error) {
      addToast('error', 'Delete failed', error.message);
    }
  }

  // Mock sign out (just redirects home)
  function handleSignOut() {
    onLogout();
    navigate('/');
  }

  const activeColMeta = COLLECTIONS.find(c => c.id === activeCol);

  return (
    <div className="adm-root">
      {/* Mobile topbar */}
      <div className="adm-mobile-topbar">
        <button className="adm-hamburger" onClick={() => setSidebarOpen(o => !o)}>
          {sidebarOpen ? <IC.Close /> : <IC.Menu />}
        </button>
        <span className="adm-mobile-brand">NovaCare Admin</span>
        <span />
      </div>

      {/* Sidebar overlay (mobile) */}
      {sidebarOpen && (
        <div className="adm-sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <div className="adm-shell">
        {/* ── Sidebar ── */}
        <aside className={`adm-sidebar${sidebarOpen ? ' open' : ''}`}>
          <div className="adm-sidebar-header">
            <div className="adm-sidebar-brand">
              <div className="adm-sidebar-brand-icon">N</div>
              <div>
                <div className="adm-sidebar-brand-name">NovaCare Lines</div>
                <div className="adm-sidebar-brand-sub">Admin Panel</div>
              </div>
            </div>
          </div>

          <nav className="adm-sidebar-nav">
            <div className="adm-nav-section-label">Collections</div>
            {COLLECTIONS.map(col => (
              <button
                key={col.id}
                className={`adm-nav-btn${activeCol === col.id ? ' active' : ''}`}
                onClick={() => { setActiveCol(col.id); setSidebarOpen(false); setSelected(null); setFormData({}); setSearch(''); }}
              >
                <span className="adm-nav-icon"><col.Icon /></span>
                {col.label}
                <span className="adm-nav-dot" />
              </button>
            ))}
          </nav>

          <div className="adm-sidebar-footer">
            <div className="adm-user-row">
              <div className="adm-user-avatar">
                D
              </div>
              <div className="adm-user-info">
                <div className="adm-user-name">Developer Mode</div>
                <div className="adm-user-role">Local Frontend Only</div>
              </div>
            </div>
            <button className="adm-signout-btn" onClick={handleSignOut}>
              <IC.LogOut /> Exit Admin
            </button>
          </div>
        </aside>

        {/* ── Main content ── */}
        <main className="adm-main">
          {/* Topbar */}
          <header className="adm-topbar">
            <div className="adm-topbar-title">
              <h1>{activeCol === 'orders' ? 'Orders' : 'Content Manager'}</h1>
              <span className="adm-collection-badge">{activeColMeta?.label}</span>
            </div>
            {activeCol !== 'orders' && (
              <button
                className="adm-btn adm-btn-primary"
                onClick={() => { setSelected(null); setFormData({}); }}
              >
                <IC.Plus /> New Item
              </button>
            )}
          </header>

          {/* Content grid — Orders get special view */}
          {activeCol === 'orders' ? (
            <div className="adm-content" style={{display:'block',padding:'24px'}}>
              <OrdersView addToast={addToast} />
            </div>
          ) : (
          <div className="adm-content">
            {/* ── List Panel ── */}
            <div className="adm-list-panel">
              <div className="adm-list-header">
                <div className="adm-list-header-top">
                  <h2>{activeColMeta?.label}</h2>
                  <span className="adm-count-badge">{filtered.length}</span>
                </div>
                <div className="adm-search-wrap">
                  <IC.Search />
                  <input
                    className="adm-search"
                    placeholder="Search…"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                  />
                </div>
              </div>
              <div className="adm-list-body">
                {filtered.length === 0 ? (
                  <div className="adm-empty">
                    <div className="adm-empty-icon"><IC.InboxEmpty /></div>
                    <h3>{search ? 'No matches' : 'No items yet'}</h3>
                    <p>{search ? 'Try a different search term.' : 'Use the editor to add your first item.'}</p>
                  </div>
                ) : (
                  filtered.map(it => (
                    <div
                      key={it.id}
                      className={`adm-item${selected?.id === it.id ? ' selected' : ''}`}
                      onClick={() => selectItem(it)}
                    >
                      <div className="adm-item-icon">
                        <activeColMeta.Icon />
                      </div>
                      <div className="adm-item-info">
                        <div className="adm-item-name">{itemLabel(it)}</div>
                        {itemSub(it) && <div className="adm-item-sub">{itemSub(it)}</div>}
                      </div>
                      <div className="adm-item-actions">
                        <button
                          className="adm-icon-btn edit"
                          title="Edit"
                          onClick={e => { e.stopPropagation(); selectItem(it); }}
                        >
                          <IC.Edit />
                        </button>
                        <button
                          className="adm-icon-btn delete"
                          title="Delete"
                          onClick={e => { e.stopPropagation(); confirmDelete(it); }}
                        >
                          <IC.Trash />
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* ── Editor Panel ── */}
            <div className="adm-editor-panel">
              <div className="adm-editor-header">
                <div className="adm-editor-header-left">
                  <h2>{selected ? 'Edit Item' : 'Add New Item'}</h2>
                  <span className={`adm-mode-badge ${selected ? 'edit' : 'add'}`}>
                    {selected ? 'Editing' : 'New'}
                  </span>
                </div>
                {selected && (
                  <button
                    className="adm-btn adm-btn-ghost"
                    onClick={() => { setSelected(null); setFormData({}); }}
                  >
                    <IC.X /> Clear
                  </button>
                )}
              </div>

              <div className="adm-editor-body">
                <StructuredForm
                  collectionId={activeCol}
                  formData={formData}
                  onChange={handleFieldChange}
                  addToast={addToast}
                />
              </div>

              <div className="adm-editor-actions">
                {selected ? (
                  <button
                    className="adm-btn adm-btn-primary"
                    onClick={handleUpdate}
                  >
                    <IC.Save /> Save Changes
                  </button>
                ) : (
                  <button
                    className="adm-btn adm-btn-primary"
                    onClick={handleAdd}
                  >
                    <IC.Plus /> Add Item
                  </button>
                )}
                <button
                  className="adm-btn adm-btn-ghost"
                  onClick={() => { setSelected(null); setFormData({}); }}
                >
                  Clear Form
                </button>
              </div>
            </div>
          </div>
          )}
        </main>
      </div>

      {/* Confirm delete modal */}
      {deleteTarget && (
        <ConfirmModal
          item={deleteTarget}
          onConfirm={handleDeleteConfirmed}
          onCancel={() => setDeleteTarget(null)}
        />
      )}
    </div>
  );
}

// ─── Root export ──────────────────────────────────────────────────────────────
export default function AdminPage() {
  const { toasts, addToast, removeToast } = useToast();
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem(AUTH_STORAGE_KEY) === 'true';
  });
  const [loginError, setLoginError] = useState('');

  const handleLogin = (username, password) => {
    if (username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password) {
      setIsAuthenticated(true);
      setLoginError('');
      if (typeof window !== 'undefined') {
        localStorage.setItem(AUTH_STORAGE_KEY, 'true');
      }
      return;
    }

    setLoginError('Invalid username or password.');
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setLoginError('');
    if (typeof window !== 'undefined') {
      localStorage.removeItem(AUTH_STORAGE_KEY);
    }
  };

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} errorMessage={loginError} />;
  }

  return (
    <>
      <ToastContainer toasts={toasts} removeToast={removeToast} />
      <AdminShell addToast={addToast} onLogout={handleLogout} />
    </>
  );
}
